/**
 * Target points calculation for applications.
 *
 * Annuity: product or policy_type contains "annuity" (case-insensitive)
 * Life: clear life signal in product/policy_type (not annuity)
 * Otherwise: null (do not guess)
 */

function haystack(product, policyType) {
  return `${product || ''} ${policyType || ''}`.toLowerCase();
}

export function isAnnuityApplication(product, policyType) {
  return haystack(product, policyType).includes('annuity');
}

export function isLifeApplication(product, policyType) {
  if (isAnnuityApplication(product, policyType)) return false;
  const hay = haystack(product, policyType);
  if (!hay.trim()) return false;
  // Clear life / IUL / term signals (covers Indexed Universal Life, IUL, Term, Pathsetter+IUL, etc.)
  return /life|\biul\b|\bterm\b|universal|\bwhole\b|variable|pathsetter|(^|[^a-z])ul([^a-z]|$)/.test(hay);
}

/**
 * @returns {number|null} computed target points, or null when ambiguous / no premium
 */
export function calculateTargetPoints({ product, policy_type, premium, premium_frequency }) {
  if (premium === '' || premium == null) return null;
  const p = typeof premium === 'number' ? premium : parseFloat(premium);
  if (Number.isNaN(p)) return null;

  if (isAnnuityApplication(product, policy_type)) {
    return Math.round(p * 0.07 * 100) / 100;
  }

  if (isLifeApplication(product, policy_type)) {
    if (String(premium_frequency || '').toLowerCase() === 'monthly') {
      return Math.round(p * 12 * 100) / 100;
    }
    return p;
  }

  return null;
}

export function parseOptionalNumber(value) {
  if (value === '' || value == null) return null;
  const n = typeof value === 'number' ? value : parseFloat(value);
  return Number.isNaN(n) ? null : n;
}
